/**
 *  Loader Container: This component contains all the type of loader used in the app.
 */
import React, { Component, ReactElement } from 'react';
import { observer } from 'mobx-react';
import { CQAppStore } from '../../../store/cq-app-store';
import { CQAppConstant } from '../../../app-constants';
import Cookies from 'universal-cookie';

/**
 * @export
 * @class LoaderContainer
 * @extends Component
 */
class LoaderContainer extends Component {

  /**
   * @returns {ReactNode}
   * @memberof LoaderContainer
   */
  public render(): ReactElement {
    const cookie = new Cookies();
    if (!CQAppStore.loader.activityIndicatorFlag) {
      return <></>;
    }
    return (
      <>
        <div className="demo-only demo--inverse">
          <div className="slds-spinner_container">
            <div role="status" className="slds-spinner slds-spinner_medium">
              <span className="slds-assistive-text">Loading</span>
              <div className="slds-spinner__dot-a"></div>
              <div className="slds-spinner__dot-b"></div>
            </div>
            {
              CQAppStore.loader.loaderMessageStatus &&
              <>
                <h2 className="slds-text-heading_small">
                  {CQAppStore.loader.loaderMessage}</h2>
              </>
            }
            {
              CQAppStore.loader.showDeployementStatus &&
              <>
                <h2 className="slds-text-heading_small">
                  Deployment in progress</h2>
                <h2 className="slds-text-heading_small">
                  <a target="_blank" href={`${cookie.get(CQAppConstant.INSTANCE_URL)}${CQAppConstant.PUBLISH_STATUS_URL}`}>View Status</a></h2>
              </>
            }
          </div>
        </div >

      </>
    );
  }
}

export const LoaderComponent = observer(
  LoaderContainer
);
